import { render, staticRenderFns } from "./PortalRfxTodoPreviewList.vue?vue&type=template&id=efcb4aae&scoped=true"
import script from "./PortalRfxTodoPreviewList.vue?vue&type=script&lang=js"
export * from "./PortalRfxTodoPreviewList.vue?vue&type=script&lang=js"
import style0 from "./PortalRfxTodoPreviewList.vue?vue&type=style&index=0&id=efcb4aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcb4aae",
  null
  
)

export default component.exports